import { Flex, Text, Image } from "@chakra-ui/react"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { useUI } from "providers/UIProvider"
import Icon from "components/UI/atoms/Icon"
import moment from "moment"
import { IHolidayItemPropsForQappAdmin } from "./HolidaysModalTypesForQappAd"

const HolidayItemForQappAdmin = ({ holiday, carWashAddress, carWashName, handleDeleteClick, handleEditClick, logoUrl, fromDate, toDate }: IHolidayItemPropsForQappAdmin) => {

    const { selectedBranchesForHolidays } = useAppContext()
    const { lang, T } = useUI()

    moment.locale(lang)
    return (
        <Flex style={{
            backgroundColor: "#E9F2FD", width: "600px", height: "4rem", boxShadow: "none",
            borderRadius: "20px", gap: "20px", justifyContent: "space-between"
        }}>
            <Flex style={{
                width: "40%", alignItems: "center", flexDirection: "row", justifyContent: "flex-start",
                gap: "10px", marginLeft: "11px", height: "4rem"
            }}>
                <Flex style={{display: "flex", marginTop: "4%", flexDirection: "column", justifyContent: "center", gap: 3, height: "100%",}}>
                {selectedBranchesForHolidays.length > 0 &&  <Image style={{borderRadius: 5}} src={logoUrl} alt="Company" height="31px" width="41px" />}
                <Text style={{fontSize: 10.5, fontWeight: "bold", justifySelf: "flex-end",}}>{carWashName}</Text>
                </Flex>
                <Text style={{ fontSize: "12px", fontWeight: "bold",  }}>{carWashAddress}</Text>
            </Flex>
            <Flex style={{ width: "40%", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                <Text style={{ fontSize: "12px", fontWeight: "bold" }}>
                {moment(fromDate).format("HH:mm - DD MMMM")} - {T("holiday.form.start_date_prefix")}
                    </Text>
                <Text style={{ fontSize: "12px", fontWeight: "bold" }}>
                {moment(toDate).format("HH:mm - DD MMMM")} - {T("holiday.form.end_date_prefix")}
                    </Text>
            </Flex>
            <Flex style={{ width: "20%", justifyContent: "center", gap: "5px", alignItems: "center", }}>
                <Flex onClick={() => handleEditClick(holiday)} style={{
                    backgroundColor: "#fff", width: "25px", height: "25px", alignItems: "center", cursor: "pointer",
             justifyContent: "center", borderRadius: "10px"
                }}>
                    <Icon name="edit" iconStyles={{ fill: "#7D90A8" }} />
                </Flex>
                <Flex onClick={() => handleDeleteClick(holiday)} style={{
                    backgroundColor: "#fff", width: "25px", height: "25px", alignItems: "center", cursor: "pointer",
                    justifyContent: "center", borderRadius: "10px"
                }}>
                    <Icon name="close" iconStyles={{ fill: "#7D90A8" }} />
                </Flex>
            </Flex>
        </Flex>
    )
}

export default HolidayItemForQappAdmin